import type { SpatialRectangle } from "../geometry/SpatialRectangle"
import type { Distance } from "../units/Units"
import type { ConcretePlotObject } from "./BasePlotObject"
import type { PlotFunction } from "./PlotFunction"

// Specific type for plot_rect
export type PlotRect = {
  func: PlotFunction.PLOT_RECT
  position: SpatialRectangle<Distance>
} & ConcretePlotObject
